import React, { useContext } from "react";
import Context from "../../../../context/conventionTrackerContext";
import { SOCIALS } from "../../../../utils/constants";
import "./index.scss";

/**
 * @desc A bar of social outlink buttons.
 */
export const SocialBar = () => {
  // CONSTANTS ----------------------------------------------------------------

  const { brand } = useContext(Context);

  // COMPONENT ----------------------------------------------------------------

  const renderSocialButtons = () => {
    const socialEntries = Object.entries(SOCIALS);
    return socialEntries.map(([key, props]) => {
      let src = props.IMAGE;
      if (typeof src === typeof {}) {
        src = src[brand];
      }
      const href =
        typeof props.LINK === typeof "" ? props.LINK : props.LINK[brand];
      if (!href) return null;
      return (
        <a
          className="social-link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          key={key}
        >
          <img src={src} alt={key} />
        </a>
      );
    });
  };

  return (
    <div className="social-bar">
      <div className="social-container">{renderSocialButtons()}</div>
    </div>
  );
};
